/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
const fn = {};
const hasFullCorsSupport = "withCredentials" in new window.XMLHttpRequest();
const hasXDomainRequest = typeof window.XDomainRequest !== "undefined";
fn.corsIsNotSupported = function() {
  return !(hasFullCorsSupport || hasXDomainRequest);
};
fn.corsIsNotEnabled = function(jqXhr) {
  return jqXhr.status === 0;
};
fn.localStorageIsNotSupported = function() {
  const test = "test";
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return false;
  } catch (e) {
    return true;
  }
};
fn.supportsPushState = function(win) {
  win = win || window;
  return !!(win.history && win.history.pushState);
};
fn.isIE = function() {
  return /(msie|trident)/i.test(navigator.userAgent);
};
fn.isFirefox = function() {
  return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
};
fn.isEdge = function() {
  return navigator.userAgent.toLowerCase().indexOf("edge") > -1;
};
fn.isSafari = function() {
  return navigator.userAgent.toLowerCase().indexOf("safari") > -1 && navigator.userAgent.toLowerCase().indexOf("chrome") === -1;
};
fn.isMac = function() {
  return navigator.platform.toUpperCase().indexOf("MAC") >= 0;
};
fn.isAndroid = function() {
  return /android/i.test(navigator.userAgent) && !/windows phone/i.test(navigator.userAgent);
};
fn.isIOS = function() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};
fn.getUserLanguages = function() {
  if (navigator.languages) {
    return [...navigator.languages];
  }
  const languages = [];
  const properties = [
    "language",
    // Safari, IE11
    "userLanguage",
    // IE
    "browserLanguage",
    // IE
    "systemLanguage"
    // IE
  ];
  properties.forEach(function(property) {
    if (navigator[property]) {
      languages.push(navigator[property]);
    }
  });
  return languages;
};
export { fn as default };
